import { Component,Input, OnInit } from '@angular/core';
import { IonItemSliding } from '@ionic/angular';
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { TranslateService } from '@ngx-translate/core';
import { BeerInfo } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BeerDetailPage_PATH } from '../../app/app-constants';


/**
 * Generated class for the BeerListEntryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-list-entry',
  templateUrl: 'beer-list-entry.html',
  styleUrls: ['./beer-list-entry.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class BeerListEntryComponent implements OnInit {
  @Input() beer : any;
  @Input() rating: any;
  @Input() removalId: any;


  constructor(
    private ancestorPage: BeerDetailPage,
    private router: Router,
    private bhutil: BhutilProvider,
    private translateService: TranslateService,
    private refdata: RefdataProvider,
    private events: AppEventService
  ) {

  }

  ngOnInit(){
  }

  showBeerDetail(beer: any) {
    this.log("TODO: show details for beer " + this.bhutil.stringify(beer));
    this.log("beer id is " + beer.id);
    let beerObj = {"beer": beer};

    let showBeerData = {
      'beer': beerObj,
      'sourcetype': 'highest-rated-beers',
      'sourceID': 1
    }
    //navigate to the detail screen, with the info preloaded
    if (this.router.url.includes(BeerDetailPage_PATH)) {
      this.log("[beer-list-entry] we are already on the beer-detail page ");
      if (this.ancestorPage) {
        this.log("[beer-list-entry] we have access to the beer-detail page ");
        // this.ancestorPage.updateModelBase(beerObj, 'highest-rated-beers');
        // this.ancestorPage.loadAnalysesAndUpdateView();
        this.events.publish("beer-list-entry:show:beer-detail", showBeerData);
      }
      else {
        this.log("[beer-list-entry] we DONT have access to the beer-detail page ");
      }
    }
    else {
      this.log("[beer-list-entry] we are NOT on the beer-detail page ");
      // this.router.navigate([ BeerDetailPage_PATH ], { state: { data: showBeerData }});
      this.router.navigateByUrl('/' + BeerDetailPage_PATH, {
        state: { data: showBeerData },
        replaceUrl: true, 
        skipLocationChange: false
      });
      //sourceID 1 == HIGHEST-RATED-BEERS
    }
  }

  getValueStr() {
    let v = this.beer.abv;
    if (v !== null && v >= 0.0) {
      v = v.toFixed(1);
      v += "%";
      return v + " " + this.translateService.instant("ADDBEER.ABV");
    } else {
      return "-% " + this.translateService.instant("ADDBEER.ABV")
    }
  }

  getImageUrl() {
    //this.log("getImageUrl for beer id: " + b.beer.id);

    if (this.beer.logo !== undefined && this.beer.logo != null) {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + this.beer.logo;
      //this.log("LOGO - using beer logo: " + logoUrlBeer);
      return logoUrlBeer;
    } else if (this.beer.brewery.logo !== undefined && this.beer.brewery.logo != null) {
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + this.beer.brewery.logo;
      //this.log("LOGO - using brewery logo: " + logoUrlBrewery);
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      //this.log("LOGO - using placeholder logo (no_logo: " + logoNoLogo);
      return logoNoLogo;
    }
  }

  getDropSize(dropNr) {
    if (this.rating) {
      if (dropNr <= this.rating) {
        return "assets/svg/icon_bh_" + "full" + ".svg";
      } else if (dropNr == this.rating + 0.5) {
        return "assets/svg/icon_bh_" + "half" + ".svg";
      } else {
        return "assets/svg/icon_bh_" + "empty" + ".svg";
      }
    }
  }

  delete(item: IonItemSliding) {
    this.events.publish("delete:beer", {beer: this.beer, item: item, removalId: this.removalId});
  }

  private log(s: string): void {
    console.log("[beer-list-entry]" + s);
  }
}
